import React from 'react';
import { useTranslation } from 'react-i18next';
import './AboutSection.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import StaffPhoto from './StaffPhoto.jpg';
import shopPhoto from './shopPhoto.jpg';
import aboutPhoto from './aboutPhoto.jpg';



const AboutSection = () => {
  const { t } = useTranslation();

  const cards = [
    {
      title: t('about.title', 'About Us'),
      image: aboutPhoto,
      imageAlt: t('about.imageAlt', 'An assortment of dishes on a table'),
      paragraph1: t('about.paragraph1', 'Lorem ipsum dolor sit amet...'),
      paragraph2: t('about.paragraph2', 'Duis aute irure dolor in...'),
    },
    {
      title: t('about.secondaryTitle', 'Our Team'),
      image: StaffPhoto,
      imageAlt: t('about.secondaryImageAlt', 'Staff photo plus a customer'),
      paragraph1: t(
        'about.secondaryParagraph1',
        'We believe in creating spaces that bring people together over good food and drinks.'
      ),
      paragraph2: t(
        'about.secondaryParagraph2',
        'Our mission is to foster community and serve with passion every single day.'
      ),
    },
    {
      title: t('about.thirdTitle', 'Vila Sol Shop'),
      image: shopPhoto, // or another relevant image
      imageAlt: t('about.thirdImageAlt', 'Coffee beans and fresh ingredients'),
      paragraph1: t(
        'about.thirdParagraph1',
        'At Vila Sol Caffe, we value quality, sustainability, and community. We source our ingredients locally whenever possible and strive to minimize our environmental impact.'
      ),
      paragraph2: t(
        'about.thirdParagraph2',
        'Our commitment to excellence is reflected in every cup and every meal. We believe in building lasting relationships with our guests and our community.'
      ),
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000, // 5 seconds per slide
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    adaptiveHeight: true,
  };

  return (
    <div className="aboutsection-background" id='about'>
      <Slider {...settings} className="aboutsection-carousel">
        {cards.map((card, index) => (
          <section className="aboutsection-container" key={index}>
            <h2 className="aboutsection-heading">{card.title}</h2>
            <img className="aboutsection-image" src={card.image} alt={card.imageAlt} />
            <p className="aboutsection-paragraph">{card.paragraph1}</p>
            <p className="aboutsection-paragraph">{card.paragraph2}</p>
          </section>
        ))}
      </Slider>
    </div>
  );
};

export default AboutSection;
